import { RouteObject } from "react-router-dom";
import EnsureUserIsAuthenticated from "../components/Security/EnsureUserIsAuthenticated";
import CallbackPage from "../pages/Authentication/Callback";
import Signin from "../pages/Signin";

export const authRoutes: RouteObject[] = [
    { path: "/auth-callback", element: <CallbackPage /> },
    { path: "/signin", element: <EnsureUserIsAuthenticated><Signin /></EnsureUserIsAuthenticated> },
];
